import PendingApps from './PendingApps.vue';

const components = [
  PendingApps,
];

export default components;



// WEBPACK FOOTER //
// ./src/components/pending-apps/index.js